// BonesCard.jsx

import React from "react";
import BasePackageCard from "./BasePackageCard";
import { BONES } from "../../../../constants";
import { useTranslation } from "../../../../language";

export default function BonesCard() {
  const { t } = useTranslation();

  const panel = {
    id: "bones",
    title: t("card_bones_title"),
    subtitle: t("card_bones_desc"),
    biomarkers: t("card_bones_markers"),
    price: "€ 129",
    image: BONES,
  };

  return <BasePackageCard panel={panel} />;
}